import React from 'react';

interface IconCloseFillCircleProps {
  className?: string;
  styleOverrides?: React.CSSProperties;
  ariaHidden?: boolean;
}

const IconCloseFillCircle: React.FC<IconCloseFillCircleProps> = ({
  className,
  styleOverrides,
  ariaHidden,
}) => (
  <svg
    style={styleOverrides}
    className={className}
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...(ariaHidden && { 'aria-hidden': true })}
  >
    <circle
      opacity="0.8"
      cx="11.2607"
      cy="10.5511"
      r="9.42024"
      fill="#292929"
      stroke="#F8F8F8"
      strokeWidth="1.74395"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8818 14.1758L14.8856 13.1719L12.1251 10.4115L14.8856 7.65093L13.8818 6.64711L11.1213 9.40765L8.36075 6.64711L7.35693 7.65093L10.1175 10.4115L7.357 13.1719L8.36082 14.1758L11.1213 11.4153L13.8818 14.1758Z"
      fill="white"
    />
  </svg>
);

export default IconCloseFillCircle;
